export const useResponsiveBannerUrl = () => {
  /**
   * Ajusta a URL do banner para sempre usar /public (melhor qualidade)
   * Normaliza removendo qualquer variante existente (/mobile, /ipad, /public)
   * e aplica /public
   */
  const getResponsiveBannerUrl = (url: string): string => {
    if (!url) return url;

    // Remove variante existente se houver, depois adiciona /public
    const baseUrl = url.replace(/\/(mobile|ipad|public)$/, '');

    return `${baseUrl}/public`;
  };

  const getResponsiveBannerUrlWithWidth = (url: string): string => {
    if (!url) return url;

    const baseUrl = url.replace(/\/(mobile|ipad|public)$/, '');

    return `${baseUrl}/public`;
  };

  return {
    getResponsiveBannerUrl,
    getResponsiveBannerUrlWithWidth,
  };
};
